"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = require("vue");

var _PropTypes = require("./PropTypes");

var _propsUtil = require("../props-util");

var _default = {
  name: 'StoreProvider',
  props: {
    store: _PropTypes.storeShape.isRequired
  },
  created: function created() {
    (0, _vue.provide)('storeContext', this.$props);
  },
  render: function render() {
    return (0, _propsUtil.getSlot)(this);
  }
};
exports.default = _default;